<template>
  <div>
    <div v-if="!editing">
      <span class="text">{{ this.text }}</span>
      <button @click="enableEditing">
        <font-awesome-icon icon="fas fa-edit" class="icon edit" />
      </button>
    </div>
    <div v-if="editing">
      <input v-model="value" class="input border-2" />
      <button @click="disableEditing">
        <font-awesome-icon icon="fa-solid fa-times" class="icon cancel" />
      </button>
      <button @click="saveEdit">
        <font-awesome-icon icon="fa-solid fa-check" class="icon save" />
      </button>
    </div>
  </div>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faEdit, faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
library.add(faEdit, faCheck, faTimes);

export default {
  name: "EditableTextField",
  props: ["text", "content"],
  data: function () {
    return {
      value: null,
      editing: false,
    };
  },
  methods: {
    enableEditing: function () {
      console.log("editing...");
      this.value = this.text;
      this.editing = true;
    },
    disableEditing: function () {
      this.value = null;
      this.editing = false;
    },
    saveEdit: function () {
      // this.text = this.value;
      this.$emit("update:content", this.value);
      this.$emit("save");
      this.disableEditing();
    },
  },
};
</script>

<style scoped>
.icon {
  margin: 0 0 0 20px;
}
.edit {
  color: darkorange;
}
.cancel {
  color: red;
}
.save {
  color: green;
}
</style>
